var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect2, _path11, _path12, _path13, _path14, _rect3, _path15, _path16, _path17, _path18, _rect4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 190,
    viewBox: "0 0 340 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 190,
    fill: "#46B4DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.875 91.0163C239.875 96.7125 244.454 101.292 250.15 101.292C255.791 101.292 260.426 96.7125 260.426 91.0163C260.426 85.3759 255.791 80.7407 250.15 80.7407C244.454 80.7407 239.875 85.3759 239.875 91.0163ZM229.767 119.944C229.767 108.328 241.327 106.262 250.095 106.43C258.695 106.597 270.255 108.552 270.255 119.944H229.767Z",
    fill: "#CAEBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.103 82.0566C267.103 86.5449 270.712 90.1532 275.2 90.1532C279.644 90.1532 283.297 86.5449 283.297 82.0566C283.297 77.6122 279.644 73.96 275.2 73.96C270.712 73.96 267.103 77.6122 267.103 82.0566ZM259.139 104.85C259.139 95.6975 268.248 94.0694 275.156 94.2014C281.933 94.3334 291.041 95.8735 291.041 104.85H259.139Z",
    fill: "#CAEBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6104 82.0566C83.6104 86.5449 87.2187 90.1532 91.707 90.1532C96.1513 90.1532 99.8036 86.5449 99.8036 82.0566C99.8036 77.6122 96.1513 73.96 91.707 73.96C87.2187 73.96 83.6104 77.6122 83.6104 82.0566ZM75.6458 104.85C75.6458 95.6975 84.7545 94.0694 91.663 94.2014C98.4395 94.3334 107.548 95.8735 107.548 104.85H75.6458Z",
    fill: "#CAEBFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.47 43.6658H228.53C233.787 43.6658 238.113 47.9249 238.113 53.0492V125.654H101.887V53.0492C101.887 47.9249 106.213 43.6658 111.47 43.6658Z",
    fill: "#3A4553"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.54 145.952L197.518 157.798L192.66 141.693L147.273 140.695L147.54 145.952Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.094 125.654V136.568C238.094 139.763 235.443 142.425 232.211 142.425H107.779C104.547 142.425 101.897 139.763 101.897 136.568V125.654H238.094Z",
    fill: "#E9E9E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.255 134.572C234.541 134.572 235.584 133.529 235.584 132.243C235.584 130.956 234.541 129.914 233.255 129.914C231.969 129.914 230.926 130.956 230.926 132.243C230.926 133.529 231.969 134.572 233.255 134.572Z",
    fill: "#3A4553"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.735 134.572C227.021 134.572 228.064 133.529 228.064 132.243C228.064 130.956 227.021 129.914 225.735 129.914C224.449 129.914 223.406 130.956 223.406 132.243C223.406 133.529 224.449 134.572 225.735 134.572Z",
    fill: "#68777B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.548 134.572C219.834 134.572 220.877 133.529 220.877 132.243C220.877 130.956 219.834 129.914 218.548 129.914C217.261 129.914 216.218 130.956 216.218 132.243C216.218 133.529 217.261 134.572 218.548 134.572Z",
    fill: "#C7CFD4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.746 159.395L147.407 142.691L197.052 156.134L198.783 159.927L143.746 159.395Z",
    fill: "#F2F2F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M206.103 158.064H135.494C133.179 158.064 131.302 159.762 131.302 161.857V161.924C131.302 164.019 133.179 165.717 135.494 165.717H206.103C208.418 165.717 210.296 164.019 210.296 161.924V161.857C210.296 159.762 208.418 158.064 206.103 158.064Z",
    fill: "#E9E9E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.47 43.6658H228.53C233.787 43.6658 238.113 47.9249 238.113 53.0492V125.654L101.887 53.0492C101.887 47.9249 106.213 43.6658 111.47 43.6658Z",
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 208.207,
    y: 22.416,
    width: 62.761,
    height: 45.0471,
    rx: 3,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M208.207 25.416C208.207 23.7592 209.55 22.416 211.207 22.416H267.968C269.625 22.416 270.968 23.7592 270.968 25.416V26.7564H208.207V25.416Z",
    fill: "#318CA9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.018 25.4679C214.473 25.4679 214.842 25.099 214.842 24.644C214.842 24.1889 214.473 23.8201 214.018 23.8201C213.563 23.8201 213.194 24.1889 213.194 24.644C213.194 25.099 213.563 25.4679 214.018 25.4679Z",
    fill: "#EBF0F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.459 25.4679C211.914 25.4679 212.283 25.099 212.283 24.644C212.283 24.1889 211.914 23.8201 211.459 23.8201C211.004 23.8201 210.635 24.1889 210.635 24.644C210.635 25.099 211.004 25.4679 211.459 25.4679Z",
    fill: "#EBF0F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.706 25.4679C217.161 25.4679 217.53 25.099 217.53 24.644C217.53 24.1889 217.161 23.8201 216.706 23.8201C216.251 23.8201 215.882 24.1889 215.882 24.644C215.882 25.099 216.251 25.4679 216.706 25.4679Z",
    fill: "#EBF0F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 124.457,
    y: 51.2874,
    width: 91.0869,
    height: 65.3782,
    rx: 3,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.457 54.2874C124.457 52.6305 125.8 51.2874 127.457 51.2874H212.543C214.2 51.2874 215.543 52.6305 215.543 54.2874V57.5867H124.457V54.2874Z",
    fill: "#318CA9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.89 55.7165C133.55 55.7165 134.086 55.1811 134.086 54.5207C134.086 53.8603 133.55 53.325 132.89 53.325C132.23 53.325 131.694 53.8603 131.694 54.5207C131.694 55.1811 132.23 55.7165 132.89 55.7165Z",
    fill: "#EBF0F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.177 55.7165C129.837 55.7165 130.373 55.1811 130.373 54.5207C130.373 53.8603 129.837 53.325 129.177 53.325C128.516 53.325 127.981 53.8603 127.981 54.5207C127.981 55.1811 128.516 55.7165 129.177 55.7165Z",
    fill: "#EBF0F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.792 55.7165C137.453 55.7165 137.988 55.1811 137.988 54.5207C137.988 53.8603 137.453 53.325 136.792 53.325C136.132 53.325 135.596 53.8603 135.596 54.5207C135.596 55.1811 136.132 55.7165 136.792 55.7165Z",
    fill: "#EBF0F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7278,
    y: 104.948,
    width: 62.761,
    height: 45.0471,
    rx: 3,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7278 107.948C70.7278 106.292 72.0709 104.948 73.7278 104.948H130.489C132.146 104.948 133.489 106.292 133.489 107.948V109.289H70.7278V107.948Z",
    fill: "#318CA9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5387 108C76.9937 108 77.3626 107.631 77.3626 107.176C77.3626 106.721 76.9937 106.353 76.5387 106.353C76.0836 106.353 75.7147 106.721 75.7147 107.176C75.7147 107.631 76.0836 108 76.5387 108Z",
    fill: "#EBF0F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9802 108C74.4352 108 74.8041 107.631 74.8041 107.176C74.8041 106.721 74.4352 106.353 73.9802 106.353C73.5251 106.353 73.1563 106.721 73.1563 107.176C73.1563 107.631 73.5251 108 73.9802 108Z",
    fill: "#EBF0F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2273 108C79.6823 108 80.0512 107.631 80.0512 107.176C80.0512 106.721 79.6823 106.353 79.2273 106.353C78.7722 106.353 78.4034 106.721 78.4034 107.176C78.4034 107.631 78.7722 108 79.2273 108Z",
    fill: "#EBF0F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.209 117.64C123.232 117.031 124.57 117.435 125.125 118.339C125.788 119.482 125.33 120.7 124.427 121.255C123.283 121.918 122.065 121.46 121.51 120.556C120.902 119.533 121.305 118.195 122.209 117.64ZM128.294 115.457L126.989 114.172L125.53 115.411L124.311 114.954L124.029 113.06C123.855 112.994 122.32 113.113 122.146 113.048L122.015 114.985C121.176 115.365 121.536 115.202 120.817 115.528L119.272 114.352L117.987 115.657L119.281 117.236C119.096 117.464 119.02 117.932 118.835 118.16C118.889 118.28 118.769 118.335 118.824 118.454L116.81 118.79L116.863 120.499L118.855 120.751C119.072 121.23 119.181 121.469 119.398 121.948L118.222 123.493C118.33 123.732 119.244 124.473 119.527 124.778L120.986 123.538C121.106 123.484 121.16 123.604 121.334 123.669C121.334 123.669 121.508 123.734 121.563 123.854C121.682 123.8 122.031 123.931 122.205 123.996L122.486 125.89L124.369 125.902L124.501 123.965C124.98 123.747 125.219 123.639 125.698 123.421L127.243 124.598L128.528 123.293L127.288 121.834C127.474 121.605 127.801 120.735 127.812 120.441L129.706 120.159C129.597 119.92 129.707 118.57 129.652 118.45L127.715 118.319C127.455 117.426 127.618 117.785 127.237 116.947L128.294 115.457Z",
    fill: "#B5005B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.854 42.9586C236.854 45.038 238.526 46.7097 240.605 46.7097C242.664 46.7097 244.356 45.038 244.356 42.9586C244.356 40.8996 242.664 39.2075 240.605 39.2075C238.526 39.2075 236.854 40.8996 236.854 42.9586ZM233.164 53.5187C233.164 49.2783 237.384 48.524 240.585 48.5852C243.724 48.6464 247.944 49.3599 247.944 53.5187H233.164Z",
    fill: "#006291"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.408 44.8751C253.408 46.9468 251.728 48.6262 249.657 48.6262C247.585 48.6262 245.906 46.9468 245.906 44.8751C245.906 42.8034 247.585 41.124 249.657 41.124C251.728 41.124 253.408 42.8034 253.408 44.8751ZM242.236 55.4146C242.236 51.1743 246.456 50.4404 249.636 50.5015C252.776 50.5423 257.016 51.2762 257.016 55.4146H242.236Z",
    fill: "#00AFEF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.427 44.8751C235.427 46.9468 233.747 48.6262 231.676 48.6262C229.604 48.6262 227.925 46.9468 227.925 44.8751C227.925 42.8034 229.604 41.124 231.676 41.124C233.747 41.124 235.427 42.8034 235.427 44.8751ZM224.235 55.4146C224.235 51.1743 228.455 50.4404 231.656 50.5015C234.795 50.5423 239.015 51.2762 239.015 55.4146H224.235Z",
    fill: "#00AFEF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M262.298 58.0389H259.846V60.5094H258.536V58.0389H256.065V56.7288H258.536V54.2583H259.846V56.7288H262.298V58.0389Z",
    fill: "#B5005B",
    stroke: "#B5005B",
    strokeWidth: 0.2,
    strokeMiterlimit: 22.9256
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M111.085 134.379C112.378 134.379 113.619 134.893 114.534 135.808C115.449 136.723 115.963 137.963 115.963 139.257C115.963 140.551 115.449 141.792 114.534 142.707C113.619 143.622 112.378 144.136 111.085 144.136C109.791 144.136 108.55 143.622 107.635 142.707C106.72 141.792 106.206 140.551 106.206 139.257C106.206 137.963 106.72 136.723 107.635 135.808C108.55 134.893 109.791 134.379 111.085 134.379Z",
    fill: "#006291"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M102.062 116.002L108.706 126.874H95.4185L102.062 116.002Z",
    fill: "#006291"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9106 132.104V141.768H89.2467V132.104H98.9106Z",
    fill: "#006291"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.178 63.8916C132.547 63.8916 129.443 65.8726 128.21 68.6681C129.443 71.4855 132.547 73.4665 136.178 73.4665C139.81 73.4665 142.914 71.4855 144.147 68.6681C142.914 65.8726 139.81 63.8916 136.178 63.8916ZM136.178 71.8597C134.153 71.8597 132.547 70.451 132.547 68.6681C132.547 66.8851 134.153 65.4764 136.178 65.4764C138.204 65.4764 139.81 66.8851 139.81 68.6681C139.81 70.451 138.204 71.8597 136.178 71.8597ZM136.178 66.753C134.946 66.753 133.999 67.5895 133.999 68.6681C133.999 69.7686 134.946 70.583 136.178 70.583C137.411 70.583 138.358 69.7686 138.358 68.6681C138.358 67.5895 137.411 66.753 136.178 66.753Z",
    fill: "#00AFEF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.704 69.2186C133.735 68.2721 135.628 66.2911 137.059 67.6998C135.716 67.6558 135.166 68.1841 134.704 69.2186Z",
    fill: "#94D9F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 148.5,
    y: 78,
    width: 43,
    height: 25,
    rx: 1,
    fill: "#006291"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 82,
    width: 27,
    height: 5,
    rx: 0.5,
    fill: "#46B4DC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 83,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#FEFEFE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 83,
    width: 20,
    height: 3,
    rx: 0.5,
    fill: "#25C5F3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 88,
    width: 27,
    height: 5,
    rx: 0.5,
    fill: "#25C5F3"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 89,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#FEFEFE"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 89,
    width: 20,
    height: 3,
    rx: 0.5,
    fill: "#94D9F8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 94,
    width: 27,
    height: 5,
    rx: 0.5,
    fill: "#94D9F8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 95,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#FEFEFE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 95,
    width: 20,
    height: 3,
    rx: 0.5,
    fill: "#CAEBFB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.03 37.0703C214.03 38.0727 214.836 38.8785 215.838 38.8785C216.83 38.8785 217.646 38.0727 217.646 37.0703C217.646 36.0778 216.83 35.2622 215.838 35.2622C214.836 35.2622 214.03 36.0778 214.03 37.0703ZM212.251 42.1606C212.251 40.1167 214.285 39.7531 215.828 39.7825C217.341 39.812 219.376 40.156 219.376 42.1606H212.251Z",
    fill: "#68777B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M222.173 43.6375H218.964L218.964 42.772H222.173L222.173 43.6375Z",
    fill: "#68777B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M82.2293 123.835C84.244 123.835 85.8773 122.202 85.8773 120.187C85.8773 118.172 84.244 116.539 82.2293 116.539C80.2145 116.539 78.5813 118.172 78.5813 120.187C78.5813 122.202 80.2145 123.835 82.2293 123.835Z",
    fill: "#94D9F8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2292 117.078C80.5121 117.078 79.1201 118.47 79.1201 120.187C79.1201 121.904 80.5121 123.296 82.2292 123.296C83.9462 123.296 85.3382 121.904 85.3382 120.187C85.3382 118.47 83.9462 117.078 82.2292 117.078ZM78.0422 120.187C78.0422 117.875 79.9168 116 82.2292 116C84.5415 116 86.4161 117.875 86.4161 120.187C86.4161 122.499 84.5415 124.374 82.2292 124.374C79.9168 124.374 78.0422 122.499 78.0422 120.187Z",
    fill: "#94D9F8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0654 122.313C79.2957 122.082 79.6692 122.082 79.8995 122.313C80.1298 122.543 80.1298 122.916 79.8995 123.147L76.2512 126.795C76.0209 127.025 75.6474 127.025 75.4171 126.795C75.1867 126.565 75.1867 126.191 75.4171 125.961L79.0654 122.313Z",
    fill: "#94D9F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.48411b794309328c5e6463a3beca9773.svg";
export { ForwardRef as ReactComponent };